export function getEnv(): "beta" | "prod" {
  return window.location.hostname === "localhost" ||
    window.location.host.includes("beta.io")
    ? "beta"
    : "prod";
}
